import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const VehicleRegistrationForm = (props) => {
  const [loading, setLoading] = useState(false);

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const frmRef = useRef({});
  const { sendRequest: postVmeRegistration } = useHttp();

  const [fuelTypes, setFuelTypes] = useState([]);
  const [fuelTypeId, setFuelTypeId] = useState("");
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getFuelType } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      vmerDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      // timeStamp: frmRef.current.time_stamp.value,
      assignedEmpId: frmRef.current.emp_id.value,
      assignedPersonDriverName: frmRef.current.person_driver_name.value,
      // assignedPersonContactNo:
      //   frmRef.current.person_driver_contact_number.value,
      // vmeClassific: frmRef.current.vme_classification.value,
      vmeClassific: "Vehicle", 
      vmeModelName: frmRef.current.modal_name.value,
      // vmeTypeCategory: frmRef.current.vme_category.value,
      vmeNo: frmRef.current.vme_number.value,
      vmeOwnershipType: frmRef.current.ownership_type.value,
      // vmeManufacYear: frmRef.current.manufacturing_year.value,
      // vmePurchaseDate: moment(frmRef.current.vme_purchase_date.value).format(
      //   "DD/MM/YYYY"
      // ),
      // lastMaintenenceDate: moment(
      //   frmRef.current.last_maintenance_date.value
      // ).format("DD/MM/YYYY"),
      // vmeOwnership: frmRef.current.vme_ownership.value,
      remark: frmRef.current.remark.value,
      // fuelTypeProductId: fuelTypeId,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      createdDate: dateString,
      serviceId: props.sId,
    };

    if (props.update) {
      data["vmerId"] = props.update.vmerId;
    }

    postVmeRegistration(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(
          `Registration details sucessfully ${
            props.update ? "updated" : "added!"
          }`
        );
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  useEffect(() => {
    getFuelType(
      {
        url: `/api/fuelTypes/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setFuelTypes(data);
      }
    );
  }, [getEmp]);

  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = props.update.vmerDate; // moment(props.update.vmerDate).format("DD-MM-YYYY" );

      setSelectedDate(props.update.vmerDate);

      frmRef.current.emp_id.value = props.update.assignedEmpId;
      // frmRef.current.time_stamp.value = moment(
      //   props.update.timeStamp,
      //   "HH:mm"
      // ).format("hh:mm");

      setEmployeeId(props.update.assignedEmpId);

      frmRef.current.person_driver_name.value =
        props.update.assignedPersonDriverName;
      // frmRef.current.person_driver_contact_number.value =
      //   props.update.assignedPersonContactNo;
      // frmRef.current.vme_classification.value = props.update.vmeClassific;
      frmRef.current.modal_name.value = props.update.vmeModelName;
      // frmRef.current.vme_category.value = props.update.vmeTypeCategory;
      frmRef.current.vme_number.value = props.update.vmeNo;
      frmRef.current.ownership_type.value = props.update.vmeOwnershipType;
      // frmRef.current.manufacturing_year.value = props.update.vmeManufacYear;
      // frmRef.current.vme_purchase_date.value = props.update.vmePurchaseDate
      //   .split("/")
      //   .reverse()
      //   .join("-");
      // frmRef.current.last_maintenance_date.value =
      //   props.update.lastMaintenenceDate.split("/").reverse().join("-");
      // frmRef.current.vme_ownership.value = props.update.vmeOwnership;
      setFuelTypeId(props.update.fuelTypeProductId);

      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-primary shadow">
                <div className="card-header">
                  <h3 className="card-title">Vehicle Registration Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        // required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        text={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    {/* <div className="col-md-4">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div> */}

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Assigned Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                        // required
                      >
                        <option value="">Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.empId} value={x.empId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"person_driver_name"}>
                        {"Assigned Person/Driver Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"person_driver_name"}
                        // required
                        ref={(el) =>
                          (frmRef.current["person_driver_name"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    
                    {/* <div className="col-md-4">
                      <label htmlFor={"person_driver_contact_number"}>
                        {"Assigned Person/Driver Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"person_driver_contact_number"}
                        required
                        ref={(el) =>
                          (frmRef.current["person_driver_contact_number"] = el)
                        }
                        className="form-control"
                      />
                    </div> */}
                    {/* <div className="col-md-4">
                      <label htmlFor={"vme_classification"}>
                        {"Truck/Vehicle/Machine/Equipment Classification"}
                      </label>
                      <select
                        id="vme_classification"
                        className="form-control"
                        required
                        ref={(el) =>
                          (frmRef.current["vme_classification"] = el)
                        }
                      >
                        {" "}
                        <option value="">Select</option>
                        <option value="Vehicle">Truck</option>
                        <option value="Vehicle">Vehicle</option>
                        <option value="Machine">Machine</option>
                        <option value="Equipment">Equipment</option>
                      </select>
                    </div> */}
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"labour_transport_cost"}>
                        {"Vehicle/Machine/Equipment Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"modal_name"}
                        // required
                        ref={(el) => (frmRef.current["modal_name"] = el)}
                        className="form-control"
                      />
                    </div>

                    {/* <div className="col-md-4">
                      <label htmlFor={"vme_category"}>
                        {"Truck/Vehicle/Machine/Equipment Type/Category"}
                      </label>
                      <select
                        id="vme_category"
                        className="form-control"
                        ref={(el) => (frmRef.current["vme_category"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="Four Tire">Four Tire</option>
                        <option value="Two Axle, Six Tire">
                          Two Axle, Six Tire
                        </option>
                        <option value="Three Axle">Three Axle</option>
                        <option value="Single Trailer">Single Trailer</option>
                        <option value="Multi Trailer">Multi Trailer</option>
                        <option value="Cleaning">Cleaning</option>
                      </select>
                    </div> */}

                    <div className="col-md-4">
                      <label htmlFor={"vme_number"}>
                        {"Truck/Vehicle/Machine/Equipment Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"vme_number"}
                        // required
                        ref={(el) => (frmRef.current["vme_number"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"ownership_type"}>
                        {" Ownership Type"}
                      </label>
                      <select
                        id="ownership_type"
                        className="form-control"
                        ref={(el) => (frmRef.current["ownership_type"] = el)}
                        // required
                      >
                        <option value="">Select</option>
                        <option value="Own">Own</option>
                        <option value="Rented">Rented</option>
                      </select>
                      
                    </div>
                  </div>

                  <div className="row">
                    
                    {/* <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Truck/Vehicle/Machine/Equipment Ownership"}
                      </label>
                      <select
                        id="vme_ownership"
                        className="form-control"
                        ref={(el) => (frmRef.current["vme_ownership"] = el)}
                        required
                      >
                        {" "}
                        <option value="">Select</option>
                        <option value="First">First</option>
                        <option value="Second">Second</option>
                        <option value="Other">Other</option>
                      </select>
                    </div> */}

                    {/* <div className="col-md-4">
                      <label htmlFor="fuelType">Fuel type</label>
                      <select
                        name="fuelTypeProductId"
                        id="fuelType"
                        className="form-control"
                        required
                        value={fuelTypeId}
                        onChange={(e) =>
                          setFuelTypeId(
                            e.target.options[e.target.selectedIndex].value
                          )
                        }
                      >
                        <option value="">Select</option>
                        {fuelTypes.map((fuelType) => (
                          <option key={fuelType.id} value={fuelType.id}>
                            {fuelType.name}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="col-md-4">
                      <label htmlFor={"manufacturing_year"}>
                        {"Manufacturing Year"}
                      </label>
                      <input
                        type={"text"}
                        id={"manufacturing_year"}
                        required
                        ref={(el) =>
                          (frmRef.current["manufacturing_year"] = el)
                        }
                        className="form-control"
                      />
                    </div> */}

                    {/* <div className="col-md-4">
                      <label htmlFor={"vme_purchase_date"}>
                        {" Purchase Date "}
                      </label>
                      <input
                        type={"date"}
                        id={"vme_purchase_date"}
                        required
                        ref={(el) => (frmRef.current["vme_purchase_date"] = el)}
                        className="form-control"
                        max={currentDate}
                      />
                    </div> */}
                  </div>
                  {/* <div className="row"> */}
                    {/* <div className="col-md-4">
                      <label htmlFor={"last_maintenance_date"}>
                        {"Last Maintenance Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"last_maintenance_date"}
                        required
                        ref={(el) =>
                          (frmRef.current["last_maintenance_date"] = el)
                        }
                        className="form-control"
                        max={currentDate}
                      />
                    </div> */}

                    
                  {/* </div> */}

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        // required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default VehicleRegistrationForm;
